/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountType {
  ADMIN = "ADMIN",
  ARCHITECT = "ARCHITECT",
  BUILDER = "BUILDER",
  E1 = "E1",
  ENGINEER = "ENGINEER",
  SUBCONTRACTOR = "SUBCONTRACTOR",
  SUPPLIER = "SUPPLIER",
}

export enum ConnectionPreferenceType {
  EQUIVALENT = "EQUIVALENT",
  SPECIFIED = "SPECIFIED",
  SPECIFIED_AND_EQUIVALENT = "SPECIFIED_AND_EQUIVALENT",
}

export enum ConsultantDiscipline {
  ARCHITECT = "ARCHITECT",
  ARCHITECT_INTERIOR = "ARCHITECT_INTERIOR",
  ARCHITECT_LANDSCAPE = "ARCHITECT_LANDSCAPE",
  CONSULTANT_FIRE = "CONSULTANT_FIRE",
  CONSULTANT_LIGHTING = "CONSULTANT_LIGHTING",
  CONSULTANT_SUSTAINABILITY = "CONSULTANT_SUSTAINABILITY",
  CONSULTANT_TECHNOLOGY = "CONSULTANT_TECHNOLOGY",
  ENGINEER_ACOUSTIC = "ENGINEER_ACOUSTIC",
  ENGINEER_CIVIL = "ENGINEER_CIVIL",
  ENGINEER_ELECTRICAL = "ENGINEER_ELECTRICAL",
  ENGINEER_FIRE = "ENGINEER_FIRE",
  ENGINEER_HYDRO = "ENGINEER_HYDRO",
  ENGINEER_MECH = "ENGINEER_MECH",
  ENGINEER_STRUCTURAL = "ENGINEER_STRUCTURAL",
  ENGINEER_THERMAL = "ENGINEER_THERMAL",
}

export enum CreditCardCompany {
  AMEX = "AMEX",
  MASTERCARD = "MASTERCARD",
  VISA = "VISA",
}

export enum EnquiryNature {
  GENERAL = "GENERAL",
  RENEWAL = "RENEWAL",
  TECHNICAL = "TECHNICAL",
  UPGRADE = "UPGRADE",
}

export enum ExperimentName {
  ADOPT_2024_SUBBLIER_PRICE_RISE_12_PERCENT_INCREASE = "ADOPT_2024_SUBBLIER_PRICE_RISE_12_PERCENT_INCREASE",
  ADOPT_2024_SUBBLIER_PRICE_RISE_20_PERCENT_INCREASE = "ADOPT_2024_SUBBLIER_PRICE_RISE_20_PERCENT_INCREASE",
  ADOPT_CHARGEBEE_INVOICE_MODAL = "ADOPT_CHARGEBEE_INVOICE_MODAL",
  ADOPT_CHARGEBEE_RENEWALS_FLOW = "ADOPT_CHARGEBEE_RENEWALS_FLOW",
  ADOPT_LITE_TO_ESSENTIAL_UPGRADE = "ADOPT_LITE_TO_ESSENTIAL_UPGRADE",
  BUILDER_DOC_RENAME_WIZARD = "BUILDER_DOC_RENAME_WIZARD",
  BUILDER_MENTION_TEAMMATES_IN_NOTES = "BUILDER_MENTION_TEAMMATES_IN_NOTES",
  BUILDER_SCOPE_OF_WORKS = "BUILDER_SCOPE_OF_WORKS",
  BUILDER_SUBBIE_DIRECTORY = "BUILDER_SUBBIE_DIRECTORY",
  BUILDER_SUBBIE_DIRECTORY_RESTRICT_ADD = "BUILDER_SUBBIE_DIRECTORY_RESTRICT_ADD",
  BUILDER_TEST = "BUILDER_TEST",
  BUILDER_VISUAL_DOC_DIFFS = "BUILDER_VISUAL_DOC_DIFFS",
  DISCO_UNIFIED_SUBBIE_PROFILE_RELEASE_1 = "DISCO_UNIFIED_SUBBIE_PROFILE_RELEASE_1",
  ITP_OTP_AUTHENTICATOR = "ITP_OTP_AUTHENTICATOR",
  NEW_IN_SUBBIE_CREDIT_EXPERIMENT = "NEW_IN_SUBBIE_CREDIT_EXPERIMENT",
  NETWORK_V2_POC = "NETWORK_V2_POC",
  PPT_CHARGEBEE_CREATE_ACCOUNT_SIGNUP = "PPT_CHARGEBEE_CREATE_ACCOUNT_SIGNUP",
  PPT_CHARGEBEE_FREE_TO_PAID_FLOW = "PPT_CHARGEBEE_FREE_TO_PAID_FLOW",
  SPECIFINDER_TRIAL_WITH_ONE_KEYWORD = "SPECIFINDER_TRIAL_WITH_ONE_KEYWORD",
  SUBBIE_ACTIVITY_FEED = "SUBBIE_ACTIVITY_FEED",
  SUBBIE_E1_USER_ITP_LOGIN_REDIRECT = "SUBBIE_E1_USER_ITP_LOGIN_REDIRECT",
  SUBBIE_ONBOARDING_FORM = "SUBBIE_ONBOARDING_FORM",
  SUBBIE_PROFILE_INSIGHTS = "SUBBIE_PROFILE_INSIGHTS",
  SUBBIE_TEST = "SUBBIE_TEST",
  SUBBLIER_PROFESSIONAL_BUNDLED_PACKAGE = "SUBBLIER_PROFESSIONAL_BUNDLED_PACKAGE",
  SUPPLIER_FIFTY_REDACTED = "SUPPLIER_FIFTY_REDACTED",
  SUPPLIER_INSIGHTS_EMAIL_USE_NEW_API = "SUPPLIER_INSIGHTS_EMAIL_USE_NEW_API",
  SUPPLIER_SPECIFINDER_DOC_FIRST_PUBLISHED_QUERY = "SUPPLIER_SPECIFINDER_DOC_FIRST_PUBLISHED_QUERY",
}

export enum FeatureName {
  AB_AUDIT = "AB_AUDIT",
  AB_CARDDAV = "AB_CARDDAV",
  AB_ENABLED = "AB_ENABLED",
  AB_MULTIPLE_CONTACT_TYPES_ENABLED = "AB_MULTIPLE_CONTACT_TYPES_ENABLED",
  ACCOUNT_USERS_RESTRICT = "ACCOUNT_USERS_RESTRICT",
  ACTION_RFQ_ENABLED = "ACTION_RFQ_ENABLED",
  ADDRESS_BOOK_APP = "ADDRESS_BOOK_APP",
  ADVANCED_PROJECT_DETAILS = "ADVANCED_PROJECT_DETAILS",
  ADVANCED_SEARCH = "ADVANCED_SEARCH",
  ADVANCED_SPEC_SEARCH = "ADVANCED_SPEC_SEARCH",
  BUILDER_PROFILE = "BUILDER_PROFILE",
  BUILDER_QUOTES = "BUILDER_QUOTES",
  COMPANY_PROFILE = "COMPANY_PROFILE",
  COMPANY_PROFILE_ADVANCED = "COMPANY_PROFILE_ADVANCED",
  CONSTRUCTION_CORRESPONDENCE = "CONSTRUCTION_CORRESPONDENCE",
  CONSTRUCTION_DELIVERY = "CONSTRUCTION_DELIVERY",
  CONSTRUCTION_MODE_ENABLED = "CONSTRUCTION_MODE_ENABLED",
  CONSULTANT_DETAILS = "CONSULTANT_DETAILS",
  CONSULTANT_INSIGHTS = "CONSULTANT_INSIGHTS",
  CREDITS_LITE_TIER = "CREDITS_LITE_TIER",
  DIRECTORY_ENABLED = "DIRECTORY_ENABLED",
  ITP_ENABLED = "ITP_ENABLED",
  ITP_REBRANDING_ENABLED = "ITP_REBRANDING_ENABLED",
  MARKET_INSIGHTS = "MARKET_INSIGHTS",
  MORE_RESTRICTIVE_BUDGET_PAYWALL = "MORE_RESTRICTIVE_BUDGET_PAYWALL",
  NETWORK_VIEW_MARKET_STATISTICS_ENABLED = "NETWORK_VIEW_MARKET_STATISTICS_ENABLED",
  OMIT_COMPETITOR_DETAILS = "OMIT_COMPETITOR_DETAILS",
  PROCUREMENT_PHASE_ENABLED = "PROCUREMENT_PHASE_ENABLED",
  PRODUCT_INSIGHTS_REPORT = "PRODUCT_INSIGHTS_REPORT",
  PROJECT_COVER_SHEETS = "PROJECT_COVER_SHEETS",
  PROJECT_SPEC_SEARCH_MAX = "PROJECT_SPEC_SEARCH_MAX",
  PROJECT_VIEW_AWARDED_ENABLED = "PROJECT_VIEW_AWARDED_ENABLED",
  PROJECT_VIEW_TENDERERS = "PROJECT_VIEW_TENDERERS",
  PROJECT_VIEW_VALUE_MAX = "PROJECT_VIEW_VALUE_MAX",
  RFQ_ENGAGEMENT = "RFQ_ENGAGEMENT",
  SPECIFICATION_INSIGHTS = "SPECIFICATION_INSIGHTS",
  SPECIFINDER_ADVANCED_SEARCH = "SPECIFINDER_ADVANCED_SEARCH",
  SPECIFINDER_KEYWORD_VARIATIONS = "SPECIFINDER_KEYWORD_VARIATIONS",
  SPECIFINDER_SAVED_KEYWORDS = "SPECIFINDER_SAVED_KEYWORDS",
  SSC_10_CREDIT = "SSC_10_CREDIT",
  SSC_15_CREDIT = "SSC_15_CREDIT",
  SSC_20_CREDIT = "SSC_20_CREDIT",
  SSC_20_TOP_UP_CREDIT = "SSC_20_TOP_UP_CREDIT",
  SSC_30_CREDIT = "SSC_30_CREDIT",
  SSC_50_CREDIT = "SSC_50_CREDIT",
  SSC_50_TOP_UP_CREDIT = "SSC_50_TOP_UP_CREDIT",
  SSC_5_CREDIT = "SSC_5_CREDIT",
  SUBBIE_ADDONS = "SUBBIE_ADDONS",
  SUBBIE_PROFILE = "SUBBIE_PROFILE",
  TENDER_CALENDAR_SYNC = "TENDER_CALENDAR_SYNC",
  TENDER_CREATE_PRIVATE_ENABLED = "TENDER_CREATE_PRIVATE_ENABLED",
  TENDER_CREATE_PUBLIC_ENABLED = "TENDER_CREATE_PUBLIC_ENABLED",
  TENDER_HANDOVER = "TENDER_HANDOVER",
  TENDER_INVITE_MAX = "TENDER_INVITE_MAX",
  TENDER_MARKET_VIEW = "TENDER_MARKET_VIEW",
  TENDER_NOTICEBOARD_ENABLED = "TENDER_NOTICEBOARD_ENABLED",
  TENDER_RETENDER = "TENDER_RETENDER",
  TENDER_SUGGESTION_ENABLED = "TENDER_SUGGESTION_ENABLED",
  TENDER_VIEW_MAX = "TENDER_VIEW_MAX",
  UNREDACT_FIFTY = "UNREDACT_FIFTY",
  WATCHLIST_ASSIGN_PROJECT_TO_USER = "WATCHLIST_ASSIGN_PROJECT_TO_USER",
}

export enum InterestLevel {
  ASSIGNED = "ASSIGNED",
  EXPLICITLY_RESET = "EXPLICITLY_RESET",
  INTERESTED = "INTERESTED",
  NOT_INTERESTED = "NOT_INTERESTED",
  QUOTED = "QUOTED",
  QUOTING = "QUOTING",
  UNACTIONED = "UNACTIONED",
}

export enum ProfileViewLogSource {
  ADDRESSBOOK = "ADDRESSBOOK",
  DIRECTORY = "DIRECTORY",
  PAGE = "PAGE",
  QUOTE = "QUOTE",
  RFQ = "RFQ",
}

export enum ProjectFilterLocationType {
  DISTANCE = "DISTANCE",
  NATIONAL = "NATIONAL",
  STATE = "STATE",
}

export enum ProjectFilterType {
  CONSULTANTS = "CONSULTANTS",
  NOTICEBOARD = "NOTICEBOARD",
  SAVED_KEYWORDS = "SAVED_KEYWORDS",
}

export enum ProjectRedactedReason {
  AWARDED = "AWARDED",
  BUDGET = "BUDGET",
  CREDIT_EXPERIMENT = "CREDIT_EXPERIMENT",
  FIFTY_PERCENT = "FIFTY_PERCENT",
  SINGLE_TENDERER = "SINGLE_TENDERER",
}

export enum ProjectStatus {
  AWARDED = "AWARDED",
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

export enum QuoteLogType {
  ADDED = "ADDED",
  COMPLETED = "COMPLETED",
  CREATED_FROM_RFQ = "CREATED_FROM_RFQ",
  DELETED = "DELETED",
  DOWNLOADED = "DOWNLOADED",
  DOWNLOADED_ANON = "DOWNLOADED_ANON",
  DOWNLOADED_BULK_PACKAGE = "DOWNLOADED_BULK_PACKAGE",
  DOWNLOADED_BULK_STAGE = "DOWNLOADED_BULK_STAGE",
  DOWNLOADED_BULK_UNCAT = "DOWNLOADED_BULK_UNCAT",
  FILE_DOWNLOADED = "FILE_DOWNLOADED",
  FILE_DOWNLOADED_ANON = "FILE_DOWNLOADED_ANON",
  PACKAGE_ASSIGNED = "PACKAGE_ASSIGNED",
  REVISED = "REVISED",
  SUBMITTED = "SUBMITTED",
  SUBMITTED_UNCAT = "SUBMITTED_UNCAT",
  VIEWED = "VIEWED",
}

export enum SearchPhraseCategory {
  BRAND = "BRAND",
  COMPETITOR = "COMPETITOR",
  OTHER = "OTHER",
  PRODUCTS = "PRODUCTS",
  SERVICE = "SERVICE",
  TRADE = "TRADE",
}

export enum SearchStatus {
  AWARDED = "AWARDED",
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StageCategory {
  AGED_CARE = "AGED_CARE",
  CIVIL = "CIVIL",
  COMMERCIAL = "COMMERCIAL",
  CORRECTIONS = "CORRECTIONS",
  DATA_CENTRE = "DATA_CENTRE",
  DEFENCE = "DEFENCE",
  EDUCATION = "EDUCATION",
  ENTERTAINMENT = "ENTERTAINMENT",
  FIT_OUT = "FIT_OUT",
  GOVERNMENT = "GOVERNMENT",
  HEALTH = "HEALTH",
  HOSPITALITY = "HOSPITALITY",
  INDUSTRIAL_HEAVY = "INDUSTRIAL_HEAVY",
  INDUSTRIAL_LIGHT = "INDUSTRIAL_LIGHT",
  MEDICAL = "MEDICAL",
  MIXED_USE = "MIXED_USE",
  OTHER = "OTHER",
  PHARMACEUTICAL = "PHARMACEUTICAL",
  RECREATION = "RECREATION",
  REFURBISHMENT = "REFURBISHMENT",
  RESIDENTIAL = "RESIDENTIAL",
  RETAIL = "RETAIL",
  TOURISM = "TOURISM",
}

export enum UserFeedbackScore {
  NEGATIVE = "NEGATIVE",
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE",
  STRONG_NEGATIVE = "STRONG_NEGATIVE",
  STRONG_POSITIVE = "STRONG_POSITIVE",
}

export enum UserPackageDownloadStatus {
  APPROVED = "APPROVED",
  AUTO_APPROVED = "AUTO_APPROVED",
  AWAITING_RESPONSE = "AWAITING_RESPONSE",
  CAN_REQUEST = "CAN_REQUEST",
  DECLINED = "DECLINED",
  REVOKED = "REVOKED",
}

export interface ActionMergeRequestInput {
  id: GraphQLEntityId;
}

export interface AddConnectionPreferenceInput {
  projectId: GraphQLEntityId;
  type: ConnectionPreferenceType;
  contactId: GraphQLEntityId;
  note?: string | null;
}

export interface AddCreditCardInput {
  userId: GraphQLEntityId;
  secureCardToken: string;
}

export interface AddKeywordsForKeywordTypeInput {
  keywords: string[];
  keywordType: SearchPhraseCategory;
}

export interface AddNoteToProjectInput {
  projectId: GraphQLEntityId;
  text: string;
}

export interface AddNoteToQuoteInput {
  id: GraphQLEntityId;
  note: string;
}

export interface AddSpecificationInsightsReportFilterInput {
  phrase: string;
  category: number;
  location: number;
}

export interface AddSpecificationInsightsReportInput {
  name: string;
  filters: AddSpecificationInsightsReportFilterInput[];
}

export interface ConsultantInsightsMatchedProjectsInput {
  consultantTypeId: GraphQLEntityId;
  searchPhraseId: GraphQLEntityId;
  consultantId: GraphQLEntityId;
  locationId: number;
}

export interface ConsultantInsightsReportInput {
  consultantTypeId: GraphQLEntityId;
  searchPhraseIds: GraphQLEntityId[];
  locationId: GraphQLEntityId;
}

export interface ConsultantProjectsInput {
  id: GraphQLEntityId;
  status: SearchStatus;
  page: number;
  sortBy: string;
  sortDir: SortDirection;
  perPage?: number | null;
  search?: string | null;
}

export interface ConsultantsInput {
  search?: string | null;
  types: number[];
  onlyFavourites: boolean;
  page: number;
  perPage?: number | null;
  sortBy?: string | null;
  sortDir: SortDirection;
  locationIds: number[];
}

export interface CreateAccountInviteInput {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface CreateQuotesForProjectInput {
  additionalFiles: UncommittedFileInput[];
  amount: number;
  details?: string | null;
  packageIds: GraphQLEntityId[];
  projectId: GraphQLEntityId;
  quoteFile: UncommittedFileInput;
}

export interface DeleteCreditCardInput {
  id: GraphQLEntityId;
}

export interface DeleteQuoteInput {
  id: GraphQLEntityId;
}

export interface DeleteSpecificationInsightsReportInput {
  id: GraphQLEntityId;
}

export interface DiscontinueLicenseInput {
  licenseId: GraphQLEntityId;
  reasons: ReasonInput[];
}

export interface FavouriteConsultantInput {
  id: GraphQLEntityId;
  isFavourite: boolean;
}

export interface GenericKeyValuePair {
  key: string;
  value: string;
}

export interface LogSupplierContactViewInput {
  projectId: GraphQLEntityId;
  supplierAccountId: GraphQLEntityId;
}

export interface MarkQuoteAsViewedInput {
  id: GraphQLEntityId;
}

export interface NotifyCancelLicencesIntentInput {
  cancellationReason: string;
}

export interface PurchaseAddonEFTInput {
  productId: GraphQLEntityId;
  billingCycle: number;
  userId: GraphQLEntityId;
  terms: boolean;
}

export interface PurchaseAddonExistingCCInput {
  productId: GraphQLEntityId;
  creditCardId: GraphQLEntityId;
  userId: GraphQLEntityId;
  billingCycle: number;
  terms: boolean;
}

export interface PurchaseAddonNewCCInput {
  productId: GraphQLEntityId;
  billingCycle: number;
  userId: GraphQLEntityId;
  secureCard?: SecureCardInput | null;
  terms: boolean;
}

export interface PurchaseLicenseUsingEFTInput {
  productId: GraphQLEntityId;
  addonIds?: GraphQLEntityId[] | null;
  billingCycle: number;
  userDetails: UserDetailsInput;
  terms: boolean;
}

export interface PurchaseLicenseUsingExistingCreditCardInput {
  productId: GraphQLEntityId;
  addonIds?: GraphQLEntityId[] | null;
  billingCycle: number;
  userDetails: UserDetailsInput;
  creditCardId: GraphQLEntityId;
  terms: boolean;
}

export interface PurchaseLicenseWithOfferUsingExistingCreditCardInput {
  productId: GraphQLEntityId;
  accountOfferId: GraphQLEntityId;
  addonIds?: GraphQLEntityId[] | null;
  billingCycle: number;
  userDetails: UserDetailsInput;
  creditCardId: GraphQLEntityId;
  terms: boolean;
}

export interface ReasonInput {
  tag: string;
  extraInfo?: string | null;
}

export interface RemoveTeamMemberInput {
  id: GraphQLEntityId;
}

export interface RequestHelpInput {
  nature: EnquiryNature;
  enquiry: string;
  route: string;
  extraInfo: GenericKeyValuePair[];
}

export interface ReviseQuoteInput {
  additionalFiles: UncommittedFileInput[];
  amount: number;
  details?: string | null;
  quoteFile: UncommittedFileInput;
  quoteId: GraphQLEntityId;
}

export interface SecureCardInput {
  secureCardToken: string;
}

export interface SuggestConsultantCorrectionInput {
  id: GraphQLEntityId;
  message: string;
}

export interface UncommittedFileInput {
  hash: string;
  fileSize: number;
  fileName: string;
  contentType?: string | null;
}

export interface UpdateCalendarSyncPreferencesInput {
  interestLevels: InterestLevel[];
}

export interface UpdateConnectionPreferenceInput {
  projectId: GraphQLEntityId;
  type: ConnectionPreferenceType;
  contactId: GraphQLEntityId;
  note?: string | null;
}

export interface UpdateLicensesBillingContactInput {
  licenseId: GraphQLEntityId;
  userId: GraphQLEntityId;
}

export interface UpdateTeamMemberInput {
  id: GraphQLEntityId;
  firstName: string;
  lastName: string;
  phone?: string | null;
  admin: boolean;
}

export interface UserDetailsInput {
  companyName?: string | null;
  companyPhone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  address1?: string | null;
  address2?: string | null;
  suburb?: string | null;
  state?: number | null;
  region?: string | null;
  postcode?: string | null;
  country: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
